<template>
  <div class="container">
    <div class="row align-items-center mt-34">
      <div class="slopePage__title">
        <b>Группировка крепежа участка</b>
      </div>
    </div>
    <div class="row" v-if="groups.length === 0">
      <div class="slopePage__info">
        <img src="@/assets/img/info-result.svg" alt="info" class="slopePage__info-img">
        <div class="slopePage__info-text">
          Для данного участка расчет крепежей отключен
        </div>
      </div>
    </div>
    <div class="row" v-if="groups.length !== 0">
      <div class="detailsPage__grouping-scroll">
        <div class="detailsPage__grouping-scroll--swipe wow fadeOut">
          <img src="@/assets/img/swipe.svg" alt="">
        </div>
        <div class="detailsPage__grouping-head"
             :class="{'detailsPage__grouping-head--expanded' : count > 1}">
          <div class="title">№</div>
          <div class="title">Толщина <br>утеплителя, <br>мм</div>
          <div class="title">Телескоп-кий <br>крепеж, <br>мм</div>
          <div class="title">Саморез <br>4.8х, <br>мм</div>
          <div class="title">Анкерный <br>элемент, <br>мм</div>
          <div class="title">Крепление <br>теплоизоляции, <br>шт</div>
          <div class="title" v-if="count > 1">
            <span>Крепление <br>теплоизоляции, <br>шт * {{ count }}уч.</span></div>
        </div>
        <div class="detailsPage__grouping-body">
          <div class="item" v-for="(item, i) in filteredGroups" :key="item.id"
               :class="{'item--expanded' : count > 1}">
            <div class="item__text"><b><i v-if="i + 1 < 10">0</i>{{ i + 1 }}</b></div>
            <div class="item__text">{{ item.thickness }}</div>
            <div class="item__text">{{ item.fastener }}</div>
            <div class="item__text">{{ item.screw }}</div>
            <div class="item__text">{{ item.ank }}</div>
            <div class="item__text">{{ item.mount }}</div>
            <div class="item__text" v-if="count > 1"><span>{{ item.totalMount }}</span></div>
          </div>
        </div>
      </div>
      <div class="detailsPage__grouping-footer"
           v-if="groups.length > 18"
           @click="isShowRemaining = !isShowRemaining"
           :class="{ active: isShowRemaining }">
        <div v-if="!isShowRemaining" class="detailsPage__grouping-footer-count">
          Показать все: {{ groups.length }}
        </div>
        <div v-else class="detailsPage__grouping-footer-count">Скрыть</div>
        <div class="detailsPage__grouping-footer-arrow">
          <img src="@/assets/img/select-tick-red.svg" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    count: Number,
  },
  data() {
    return {
      isShowRemaining: false,
      /*groups: [
        {
          id: 0,
          thickness: 100,
          fastener: 80,
          screw: 80,
          ank: '8х45 или нет',
          mount: 10,
        },
        {
          id: 1,
          thickness: 100,
          fastener: 80,
          screw: 80,
          ank: '8х45 или нет',
          mount: 10,
        },
        {
          id: 2,
          thickness: 100,
          fastener: 80,
          screw: 80,
          ank: '8х45 или нет',
          mount: 10,
        },
        {
          id: 3,
          thickness: 100,
          fastener: 80,
          screw: 80,
          ank: '8х45 или нет',
          mount: 10,
        },
        {
          id: 4,
          thickness: 100,
          fastener: 80,
          screw: 80,
          ank: '8х45 или нет',
          mount: 10,
        },
        {
          id: 5,
          thickness: 100,
          fastener: 80,
          screw: 80,
          ank: '8х45 или нет',
          mount: 10,
        },
        {
          id: 6,
          thickness: 100,
          fastener: 80,
          screw: 80,
          ank: '8х45 или нет',
          mount: 10,
        },
        {
          id: 7,
          thickness: 100,
          fastener: 80,
          screw: 80,
          ank: '8х45 или нет',
          mount: 10,
        },
        {
          id: 8,
          thickness: 100,
          fastener: 80,
          screw: 80,
          ank: '8х45 или нет',
          mount: 10,
        },
        {
          id: 9,
          thickness: 100,
          fastener: 80,
          screw: 80,
          ank: '8х45 или нет',
          mount: 10,
        },
      ],*/
    };
  },
  components: {
  },
  methods: {
  },
  watch: {
  },
  mounted() {
  },
  computed: {
    sortedGroups() {
      return this.groups.sort((a, b) => {
        return a.thickness - b.thickness;
      });
    },
    filteredGroups() {
      return this.isShowRemaining ? this.sortedGroups : this.sortedGroups.slice(0, 18);
    },
    slopeId() {
      return (this.$route.params.id) ? this.$route.params.id : 0;
    },
    result() {
      return this.$store.getters.getResult;
    },
    groups() {
      return this.result.sections[this.$route.params.id].fasteners_group;
    },
  },
};
</script>

<style lang="sass" scoped>
.detailsPage
  .mt-34
    margin-top: rem(34)
  .slopePage
    &__title
      +media((font-size: (320: rem(18), 992: rem(24))))
      +media((line-height: (320: rem(26), 992: rem(29))))
      +media((padding-top: (320: rem(11), 992: rem(36))))
      +media((padding-bottom: (320: rem(30), 992: rem(36))))
      // opacity: 0
      // animation-delay: .5s
      // animation-duration: 2.5s
  &__grouping
    &-scroll
      +media((width: (320: auto, 768: 100%)))
      display: flex
      flex-direction: column
      overflow-x: auto
      position: relative
      &--swipe
        +media((display: (320: flex, 768: none)))
        position: absolute
        height: 100%
        background: rgba(0, 0, 0, 0.5)
        flex-direction: row
        align-items: center
        justify-content: center
        width: 100vw
        opacity: 0
        pointer-events: none
        animation-duration: 3s
        img
          width: rem(70)
          animation: swiping 1.5s infinite ease
          position: absolute
          left: 50%
          display: inline-block
    &-head
      display: grid
      grid-template-columns: 2fr 3fr 4fr 3fr 4fr 4fr
      +media((width: (320: 220vw, 360: 200vw, 580: 180vw, 680: 130vw, 768: 120vw, 992: 100%)))
      &--expanded
        grid-template-columns: 2fr 3fr 4fr 3fr 4fr 4fr 4fr
      @extend .common__result-header
      .title
        @extend .common__title-result
        text-align: left
        display: flex
        flex-direction: row
        align-items: center
        padding: rem(19) 0 rem(17)
        &:first-of-type
          padding-left: rem(20)
        span
          color: #999999
        white-space: nowrap
    &-body
      +media((width: (320: 220vw, 360: 200vw, 580: 180vw, 680: 130vw, 768: 120vw, 992: 100%)))
      .item
        background: #FFFFFF
        box-shadow: inset 0 rem(-1) 0 #D6D6D6
        display: grid
        grid-template-columns: 2fr 3fr 4fr 3fr 4fr 4fr
        &--expanded
          grid-template-columns: 2fr 3fr 4fr 3fr 4fr 4fr 4fr
        &__text
          font-style: normal
          font-weight: 500
          line-height: rem(30)
          padding: rem(10) 0
          text-align: left
          +media((font-size: (320: rem(14), 768: rem(16))))
          &:first-of-type
            padding-left: rem(20)
          span
            color: #999999
          i
            font-style: normal
    &-footer
      display: flex
      flex-direction: row
      align-items: center
      justify-content: space-between
      cursor: pointer
      @extend .common__result-footer
      &-count
        @extend .common__result-footer--count
      &-arrow
        @extend .common__result-footer--arrow
      &.active
        .detailsPage__grouping-footer-arrow
          img
            transform: rotate(180deg)
</style>
